import { render, staticRenderFns } from "./ReviewPage4.vue?vue&type=template&id=d8d407be&"
import script from "./ReviewPage4.vue?vue&type=script&lang=js&"
export * from "./ReviewPage4.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPage4.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports